export const safeFileName = (name = "download", extension = "png") => {
  const cleanedName = String(name || "download")
    .trim()
    .replace(/\.[^.]+$/i, "")
    .replace(/[^a-z0-9_-]+/gi, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();

  return `${cleanedName || "download"}.${extension}`;
};

export const downloadRemoteFile = async (url, fileName) => {
  const response = await fetch(url, { mode: "cors" });
  if (!response.ok) {
    throw new Error("Unable to download file");
  }

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(blobUrl);
};

export const downloadAuthenticatedFile = async (url, { token, fileName = "download" } = {}) => {
  const headers = token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};

  const response = await fetch(url, {
    headers,
  });

  if (!response.ok) {
    throw new Error("Unable to download file");
  }

  const blob = await response.blob();
  const resolvedFileName =
    getFileNameFromDisposition(response.headers.get("content-disposition") || "") ||
    fileName;
  const blobUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  anchor.download = resolvedFileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(blobUrl);
};

export const downloadCanvasPng = (canvas, fileName) => {
  if (!canvas) {
    throw new Error("Canvas not found");
  }

  const anchor = document.createElement("a");
  anchor.href = canvas.toDataURL("image/png");
  anchor.download = fileName;
  anchor.click();
};

const getFileNameFromDisposition = (contentDisposition = "") => {
  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1].replace(/["']/g, ""));
  }

  const match = contentDisposition.match(/filename="?([^"]+)"?/i);
  return match?.[1] || "";
};

export const downloadQrAttachment = async ({ baseUrl, id, token, title = "qr-code", format = "png" }) => {
  if (!id) {
    throw new Error("QR id is required");
  }

  const response = await fetch(`${baseUrl}/api/Qr/${id}/download?format=${format}`, {
    headers: {
      Authorization: `Bearer ${token || ""}`,
    },
  });

  const contentType = response.headers.get("content-type") || "";
  if (!response.ok) {
    throw new Error("Unable to download QR");
  }

  if (contentType.includes("application/json")) {
    const payload = await response.json();
    const downloadUrl = payload?.data?.url;
    if (!downloadUrl || payload?.error) {
      throw new Error(payload?.message || "Unable to download QR");
    }

    await downloadRemoteFile(downloadUrl, safeFileName(title, format));
    return;
  }

  const blob = await response.blob();
  const fileName =
    getFileNameFromDisposition(response.headers.get("content-disposition") || "") ||
    safeFileName(title, format);
  const blobUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = blobUrl;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(blobUrl);
};
